    
    const abr = {
    maxBufferlength : 30,
    noOfPlaylist : 3,
    max: 0,
    min: 30,
    lastValue: 30,
    set1: new Set([]),
    set2: new Set(),
    set3: new Array(),
    bufferPastFactor: 5,
    currentBitrate: 0,
    currentLevel: 0,
    rebufferingRatio: 0.3,
    avgBitrate: 0,
    avgBuffer: 0,
    player: {},
    playingTime: 0,
    rebufferingTime: 0,
    rebufferingParameter: 0.3,
    ratio: 0,
    
    getCurrentLevel: () => {
        for (var i = 0; i<= abr.set3.length; i++) {
           if(abr.set3[i] == abr.currentBitrate){
               abr.currentLevel = i
               return i
           }
        }
    },
    getPlayer: (player) => {
        abr.player = player
    },

    getPlayingTime: () => {
        abr.playingTime = abr.playingTime +1
        console.log("Playing time", abr.playingTime)
    },

    getRebufferingTime: () => {
        abr.rebufferingTime = abr.rebufferingTime + 1
        console.log("Rebuffering time", abr.rebufferingTime)
    },
    getRebufferingRatio: () => {
        abr.ratio = abr.rebufferingTime / abr.playingTime
        abr.checkRebufferingRatio(abr.ratio, abr.rebufferingRatio)
    },

    getPlaylist: (bitrates) =>{
        for (var i = 0; i<bitrates.length;i++ ) {
            var bitrate = bitrates[i].attrs.BANDWIDTH
            console.log("bitrate",bitrate)
            abr.set3.push(bitrate)
          }
          abr.set3.sort(function(a, b){return a-b}); //acesnding order
    },
    getBufferValue: (value) => {
        console.log("Buffervalue", value)
        if (abr.lastValue < value) {
            console.log("max,min",abr.min,abr.max)
            abr.set1.add([abr.max,abr.min])
            abr.max = value
            abr.lastValue = value
            abr.min = value
        }
        if (value > abr.max) {
            abr.max = value
        }
        if (value < abr.min) {
            abr.min = value
            abr.lastValue = abr.min
        }
        
        abr.getBestLevel()
    },
    getBestLevel: async() =>{
        console.log("set1.size",abr.set1.size)
        if (abr.set1.size == abr.bufferPastFactor) {
            abr.player.nextLevel = abr.getCurrentLevel()
            for (const entry of abr.set1) {
                    console.log("abr.set1",entry)
                    abr.avgBuffer = entry[1] + abr.avgBuffer
                }
                abr.avgBuffer = abr.avgBuffer / abr.bufferPastFactor
                console.log("avgBuffer",abr.avgBuffer)

            for (const entry of abr.set2) {
                console.log("abr.set2",entry)
                abr.avgBitrate = entry + abr.avgBitrate 
            }
            abr.avgBitrate = (abr.avgBitrate * 8 * 1000) / abr.set2.size
            console.log("avgBitrate",abr.avgBitrate) 
            // convert bytesperms to bitspersecond (in playlist bitrate is in bits persecond.)
            console.log("currentBitrate", abr.currentBitrate)
            
            console.log(abr.currentBitrate, abr.set3[0])
            // if (abr.avgBuffer <= (10*abr.maxBufferlength)/100 ) {
            //     if (abr.currentBitrate > abr.set3[0]) {
            //         abr.player.abrController.hls.nextLevel = 0
            //     }
            // }
            if (abr.avgBuffer > ((1*abr.maxBufferlength)/100) && abr.avgBuffer <= (10*abr.maxBufferlength)/100) {
                if (abr.currentBitrate >= abr.set3[0]) {
                    console.log("Shift to smallest one if not already")
                    // abr.player.loadLevel = 0
                    abr.reset()
                    return 0
                } else {
                    console.info("Poor Network Connection, Already playing in lowest Quality")
                    abr.reset()
                    return
                }
            }
            if ((abr.avgBuffer > (10*abr.maxBufferlength)/100) && abr.avgBuffer <= (20*abr.maxBufferlength)/100){
                console.log("Stay")
                abr.reset()
                return
            }
            if (abr.avgBuffer > (20*abr.maxBufferlength)/100 && abr.avgBuffer <= (30*abr.maxBufferlength)/100){
                if (abr.currentBitrate < abr.avgBitrate) {
                    console.log("2.1")
                    for (var i = 0; i< abr.set3.length; i++) {
                        console.log("2.2")
                         if  (abr.set3[i] == abr.currentBitrate) {
                            console.log("2.3")
                             if (abr.avgBitrate >= abr.set3[i] && i < abr.set3.length) {
                                //  abr.player.loadLevel = i+1
                                 abr.reset()
                                 return i+1
                             } else {
                                 abr.reset()
                                 return;
                             }
                         }
                    }
                    // find the level of current bitrate and then shift to next one after comparing the avgBitrate with the shifting one.
                } else {
                    abr.reset()
                    return
                }
                // is it necessary? 
            }
            if (abr.avgBuffer > (30*abr.maxBufferlength)/100) {
                if (abr.currentBitrate < abr.avgBitrate) {
                    console.log("1.1")
                    for (var i = 0; i< abr.set3.length; i++) {
                        console.log("1.2",abr.set3[i],abr.currentBitrate)
                        if (abr.set3[i] == abr.currentBitrate && i < abr.set3.length -1) { // check the current bitrate and see if it is not the last one. 
                            console.log("1.3",abr.set3[abr.set3.length-1],abr.avgBitrate)
                            if (abr.set3[abr.set3.length-1] <= abr.avgBitrate) {
                                console.log("Shift to highest quality")
                                // abr.player.loadLevel = abr.set3.length - 1
                                abr.reset()
                                return abr.set3.length -1
                            } else {
                                console.log("Shift to middle quality")

                                // abr.player.loadLevel = abr.set3.length - 2
                                abr.reset()
                                return abr.set3.length -2
                            }
                        } else {
                            abr.reset()
                            return
                        }
                    }
                } else {
                    abr.reset()
                    return
                }
                // compare the avgBitrate with the one in which it is to be shifted, if yes then shift
            }
            // remove the historical data. 
            abr.reset() 
        }   else {
            abr.currentLevel = abr.getCurrentLevel()
            console.log("abr.currentlevel", abr.currentLevel)
            // abr.player.loadLevel = abr.currentLevel
            return abr.currentLevel;
        }
    },
        getBitrate: (bitrate) => {
            var bitrate = bitrate
            abr.set2.add(bitrate)
        },
        // based on the basis of class intervals. 
    
        checkRebufferingRatio: async(ratio, parameter) =>{
            console.log("CheckRebuffering")
            if (ratio > parameter) {
                abr.getCurrentLevel()
                if(abr.currentLevel == 0) {
                    console.log("Poor Network, already playing in lowest quality")
                } else {
                    console.log("Shifting level -1")
                    // abr.player.loadLevel = abr.currentLevel - 1
                    abr.reset()
                    return abr.currentLevel -1
                }               
            } else {
                return abr.currentLevel
            }

        },
        reset: () =>{
            abr.avgBitrate = 0
            abr.avgBuffer = 0
            abr.set1.forEach(function(points){
                abr.set1.delete(points);
            });
            abr.set2.forEach(function(points){
                abr.set2.delete(points);
            });
        }
    }
     
    // Based on percentage basis
    
    

export default {
    abr,
};
 


// WEBPACK FOOTER //
// ./src/abrCustom.js